import { PriceChartConstants } from "../../../../Constants/PriceChartConstants";
import { TranslateHelper } from "../../../../Utils/TranslateHelper";
import GraphComponent from "../../../../Constants/GraphComponent";
const { ActionTypes } = PriceChartConstants;

const initialState = {
    priceMenu: [],
    label: TranslateHelper.PRICE,
    isPriceLabelsDisabled: false
}

const PriceMenuReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.PRICE_MENU_READY:
            const isPriceLabelsDisabled = Object.values(action.blockMenu)
                                                .filter((menu) => menu.graphComponent === GraphComponent.HiLoPct || menu.graphComponent === GraphComponent.HiLo)
                                                .every((menu) => menu.isDisable === true);
            return {
                ...state,
                priceMenu: action.blockMenu,
                label: action.label,
                isPriceLabelsDisabled: isPriceLabelsDisabled
            }
        case ActionTypes.DISABLE_DEFAULT_PRICE_LABELS:
            const blockMenu = [...state.priceMenu];
            blockMenu.forEach((menu) => {
                if (menu.graphComponent === GraphComponent.HiLoPct || menu.graphComponent === GraphComponent.HiLo) {
                    menu.isDisable = action.isDisabled;
                }
                // updating zigzag price menu item active status
                if (menu.graphComponent === GraphComponent.ZZIndicator) {
                    menu.items[0].isActive = action.isDisabled;
                }
            });

            return { ...state, priceMenu: blockMenu, isPriceLabelsDisabled: action.isDisabled }
        default:
            return state;
    }
}
export default PriceMenuReducer;
